import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import { Formik, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { changePasswordValidationSchema, deleteProfileValidationSchema } from '../ValidationSchema';
import { Form, useNavigate } from 'react-router-dom';
import { changePassword, deleteProfile, fetchProfileStatus, getDeleteReason, privacySetting, privacySettingShow, toggleProfileVisibility } from '../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { ExpandMore } from '@mui/icons-material';

export const Setting = () => {
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState('');
    const [openOtpDialog, setOpenOtpDialog] = useState(false);
    const [deleteReason, setDeleteReason] = useState([]);
    const [profileVisibility, setProfileVisibility] = useState(0);
    const mobile = localStorage.getItem('mobile_number');
    const email = localStorage.getItem('email');
    const [settings, setSettings] = useState({
        contact_setting: 1,
        send_interest_setting: 1,
        chatting_setting: 1,
        // tokan: tokan
    })
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPrivacySetting = async () => {
            try {
                const response = await privacySettingShow();
                // Check for successful response
                if (response.status === 200 || response.status === 201) {

                    const data = response.data.data;

                    // Handle empty or missing data
                    if (data && Object.keys(data).length > 0) {
                        setSettings(data);
                    } else {
                        console.warn("No privacy settings data available.");
                        // Provide default values or message to the user
                        setSettings({
                            contact_setting: 1, // Default setting or placeholder
                            send_interest_setting: 1,
                            chatting_setting: 1,
                        });
                    }
                } else {
                    console.error("Failed to update settings:", response.statusText);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };
        fetchPrivacySetting();
    }, []);
    const formik = useFormik({
        initialValues: {
            old_password: '',
            new_password: '',
            confirm_password: '',
            // tokan: localStorage.getItem('token')
        },
        validationSchema: changePasswordValidationSchema,
        onSubmit: async (values) => {

            if (step === 1) {
                try {
                    const response = await changePassword({
                        old_password: values.old_password,
                        new_password: values.new_password,
                        confirm_password: values.confirm_password,
                        step: 1,
                    });

                    if (response.data.status === 200 || response.data.status === 201) {
                        toast.success(response.data.message);
                        setStep(2);
                        setOpenOtpDialog(true);
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error(error.response.data.message);
                }
            } else if (step === 2) {
                try {
                    const response = await changePassword({
                        old_password: values.old_password,
                        new_password: values.new_password,
                        confirm_password: values.confirm_password,
                        otp: otp,
                        step: 2,
                    });

                    if (response.data.status === 200 || response.data.status === 201) {
                        toast.success('Password Changed Successfully');
                        setStep(1);
                        formik.resetForm();
                        setOpenOtpDialog(false);
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error(error.response.data.message);
                }
            }
        }
    });

    const deleteFormik = useFormik({
        initialValues: {
            delete_reason: '',
        },
        validationSchema: deleteProfileValidationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const response = await deleteProfile({ ...values });
                if (response.status === 200 || response.status === 201) {
                    toast.success('Profile Deleted Successfully')
                    localStorage.removeItem('token');
                    navigate('/');
                }
            } catch (error) {
                toast.error(error.response?.message);
            } finally {
                setSubmitting(false);
            }
        }
    })
    useEffect(() => {
        const accordionHeaders = document.querySelectorAll('.accordion-header');

        const handleAccordionClick = (event) => {
            const button = event.currentTarget;
            const accordionContent = button.nextElementSibling;

            button.classList.toggle('active');
            if (button.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
            } else {
                accordionContent.style.maxHeight = 0;
            }
            accordionHeaders.forEach((otherButton) => {
                if (otherButton !== button) {
                    otherButton.classList.remove('active');
                    otherButton.nextElementSibling.style.maxHeight = 0;
                }
            });

        };
        accordionHeaders.forEach(button => {
            button.addEventListener('click', handleAccordionClick);
        });

        return () => {
            accordionHeaders.forEach(button => {
                button.removeEventListener('click', handleAccordionClick);
            });
        };
    }, []);

    useEffect(() => {
        const fetchDeleteReason = async () => {
            try {
                const response = await getDeleteReason();
                if (response.status === 200 || response.status === 201) {
                    setDeleteReason(response.data);
                } else {
                    toast.error("Something Went Wrong Please try again letter")
                }
            } catch (error) {
                toast.error(error.message);
            }
        };

        const fetchProfileVisibility = async () => {
            try {
                const response = await fetchProfileStatus();
                if (response.status === 200 || response.status === 201) {
                    setProfileVisibility(response.data.data.hideProfile);
                } else {
                    toast.error('Failed to fetch profile visibility data');
                }
            } catch (error) {
                toast.error(error);
            }
        }
        fetchProfileVisibility();
        fetchDeleteReason();
    }, []);
    const handleToggleVisibility = async () => {
        try {
            const newStatus = profileVisibility === 0 ? 1 : 0;
            const response = await toggleProfileVisibility({ 'status': newStatus });
            if (response.status === 200 || response.status === 201) {
                setProfileVisibility(response.data.data);
                toast.success(`Profile ${response.data.data === 0 ? 'Unhidden' : 'Hidden'} Successfully`);
            } else {
                toast.error('Failed to toggle profile visibility');
            }
        } catch (error) {
            toast.error(error);
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings((prevSettings) => ({ ...prevSettings, [name]: parseInt(value, 10) }));
    };

    const handleSave = async () => {
        const updatedSettings = { ...settings };
        const response = await privacySetting(updatedSettings);
        console.log("response", response.data);

        if (response.status === 200 || response.status === 201) {
            toast.success(response.data.message);
        } else {
            toast.error("Failed to update settings. Please try again.");
        }
    };

    const handleOtpChange = (e) => setOtp(e.target.value);
    return (
        <div className="col-lg-9 col-12 text-left">
            <Card>
                <CardHeader
                    avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
                    title="Account Settings"
                    subheader="Update these details to get suitable matches"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <div className="accordion-container mt-4">
                    <div className="accordion-item">
                        <button className="accordion-header">Privacy Settings <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="accountSet">
                                <h5>Privacy Settings</h5>
                                <p className="m-0">These settings help you control and manage your privacy</p>
                            </div>

                            <p className="showSetting">Who Can Contact Me</p>
                            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                {['Anyone', 'Only member who meet my criteria', 'Only to Interest Sent/Accepted'].map((label, index) => (
                                    <div style={{ display: 'flex', alignItems: 'center' }} key={index}>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="contact_setting"
                                            id={`mobile-outlined${index + 1}`}
                                            autoComplete="off"
                                            checked={settings.contact_setting === index + 1}
                                            onChange={handleChange}
                                            value={index + 1}
                                            style={{ marginRight: '10px' }}
                                        />
                                        <label className="btn btn-outline-success" htmlFor={`mobile-outlined${index + 1}`}>{label}</label>
                                    </div>
                                ))}
                            </div>

                            <p className="showSetting">Who Can Send Interest</p>
                            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                {['Anyone', 'Only member who meet my criteria'].map((label, index) => (
                                    <div style={{ display: 'flex', alignItems: 'center' }} key={index}>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="send_interest_setting"
                                            id={`email-outlined${index + 1}`}
                                            autoComplete="off"
                                            checked={settings.send_interest_setting === index + 1}
                                            onChange={handleChange}
                                            value={index + 1}
                                            style={{ marginRight: '10px' }}
                                        />
                                        <label className="btn btn-outline-success" htmlFor={`email-outlined${index + 1}`}>{label}</label>
                                    </div>
                                ))}
                            </div>

                            <p className="showSetting3">Who Can Chat With Me</p>
                            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                {['Anyone', 'Only member who meet my criteria', 'Only to Interest Sent/Accepted'].map((label, index) => (
                                    <div style={{ display: 'flex', alignItems: 'center' }} key={index}>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="chatting_setting"
                                            id={`profile-outlined${index + 1}`}
                                            autoComplete="off"
                                            checked={settings.chatting_setting === index + 1}
                                            onChange={handleChange}
                                            value={index + 1}
                                            style={{ marginRight: '10px' }}
                                        />
                                        <label className="btn btn-outline-success" htmlFor={`profile-outlined${index + 1}`}>{label}</label>
                                    </div>
                                ))}
                            </div>

                            <Grid item xs={5} md={5} mt={5}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                    <button
                                        className="btn btn-danger col-2"
                                        style={{
                                            width: window.innerWidth <= 767 ? '100%' : 'auto',
                                            marginBottom: window.innerWidth <= 767 ? '1rem' : '0',
                                        }}
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                </div>
                            </Grid>
                        </div>
                    </div>


                    <div className="accordion-item">
                        <button className="accordion-header">Hide/Delete Profile <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div>
                                <div className="accountSet">
                                    <h5>Hide Profile</h5>
                                    <p className="m-0">You can view profiles but won't be able to send interests or messages,
                                        and your profile will not be shown to others</p>
                                </div>
                                <p className="showSetting">Hide Profile</p>
                                <div className="py-4">
                                    <Button
                                        className="btn btn-danger"
                                        color="secondary"
                                        variant="contained"
                                        onClick={handleToggleVisibility}
                                    >
                                        {profileVisibility === 0 ? 'Hide My Profile' : 'Unhide My Profile'}
                                    </Button>
                                </div>
                            </div>
                            <hr />
                            <div>
                                <div className="accountSet">
                                    <h5>Delete Profile</h5>
                                    <p className="m-0">This will permanently delete your profile along with all matches
                                        and chat/call history</p>
                                </div>
                                <p className="showSetting">Reason for Deleting Profile</p>
                                <Formik>
                                    <form onSubmit={deleteFormik.handleSubmit}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-label="delete-reason"
                                                name="delete_reason"
                                                value={deleteFormik.values.id}
                                                onChange={deleteFormik.handleChange}
                                            >
                                                {deleteReason.map((reason) => (
                                                    <FormControlLabel
                                                        key={reason.id}
                                                        value={reason.id}
                                                        control={<Radio />}
                                                        label={reason.Delete_reason}
                                                    />
                                                ))}
                                            </RadioGroup>
                                            <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            disabled={deleteFormik.isSubmitting}
                                            className="mt-3"
                                        >
                                            Delete My Profile
                                        </Button>
                                        </FormControl>
                              
                                    </form>
                                </Formik>
                            </div>
                        </div>
                    </div>
                    <div className="accordion">
                        <button className="accordion-header">Change Password <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    <div className="changPass">
                                        <Grid item xs={12} sm={6}>

                                            <form onSubmit={formik.handleSubmit}>
                                                <TextField
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Current Password"
                                                    type="password"
                                                    name="old_password"
                                                    size='small'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.old_password}
                                                    error={formik.touched.old_password && Boolean(formik.errors.old_password)}
                                                    helperText={formik.touched.old_password && formik.errors.old_password}
                                                />
                                                <TextField
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="New Password"
                                                    type="password"
                                                    name="new_password"
                                                    size='small'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.new_password}
                                                    error={formik.touched.new_password && Boolean(formik.errors.new_password)}
                                                    helperText={formik.touched.new_password && formik.errors.new_password}
                                                />
                                                <TextField
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Confirm New Password"
                                                    type="password"
                                                    name="confirm_password"
                                                    size='small'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.confirm_password}
                                                    error={formik.touched.confirm_password && Boolean(formik.errors.confirm_password)}
                                                    helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                                                />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="error"
                                                    fullWidth
                                                    sx={{ mt: 3 }}
                                                // disabled={formik.isSubmitting}
                                                >
                                                    {/* {formik.isSubmitting ? 'Saving...' : 'Save New Password'} */}
                                                    {step === 1 ? 'Send Otp' : 'Verify OTP and change password'}
                                                </Button>
                                            </form>
                                            <Dialog open={openOtpDialog} onClose={() => setOpenOtpDialog(false)}>
                                                <DialogTitle>Enter OTP</DialogTitle>

                                                <DialogContent>

                                                    <TextField
                                                        fullWidth
                                                        margin="normal"
                                                        variant="outlined"
                                                        label="OTP"
                                                        type="text"
                                                        name="otp"
                                                        size='small'
                                                        onChange={handleOtpChange}
                                                        onBlur={formik.handleBlur}
                                                        value={otp}
                                                        error={formik.touched.otp && Boolean(formik.errors.otp)}
                                                        helperText={formik.touched.otp && formik.errors.otp}
                                                    />
                                                </DialogContent>
                                                <DialogActions>

                                                    <Button onClick={() => setOpenOtpDialog(false)}>Cancel</Button>
                                                    <Button
                                                        onClick={() => formik.handleSubmit()}
                                                        color="primary"
                                                    >
                                                        Verify OTP
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </Card>
            <ToastContainer />
        </div>
    )
}
